export const ROLE_OPTIONS = [
  { value: "agent", label: "Agente" },
  { value: "agent_l2", label: "Agente L2" },
  { value: "admin", label: "Administrador" }
];

export function getRoleLabel(role) {
  return ROLE_OPTIONS.find((option) => option.value === role)?.label || "Agente";
}

export function hasRole(user, roles) {
  const allowedRoles = Array.isArray(roles) ? roles : [roles];
  return allowedRoles.includes(user?.role);
}
